import React from 'react';
import { CalendarDaysIcon, LayoutDashboardIcon, TagsIcon, LineChartIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { useJournal } from '../../context/JournalContext';
import { useAuth } from '../../context/AuthContext';
import { cn } from '../../lib/cn';
export type TabKey = 'calendar' | 'dashboard' | 'tags' | 'trash' | 'profile';
const items: {
  key: TabKey;
  label: string;
  icon: React.ElementType;
}[] = [{
  key: 'calendar',
  label: 'Calendario',
  icon: CalendarDaysIcon
}, {
  key: 'dashboard',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  key: 'tags',
  label: 'Etiquetas',
  icon: TagsIcon
}, {
  key: 'trash',
  label: 'Papelera',
  icon: Trash2Icon
}, {
  key: 'profile',
  label: 'Mi perfil',
  icon: UserIcon
}];
export function Sidebar({
  active,
  onChange
}: {
  active: TabKey;
  onChange: (t: TabKey) => void;
}) {
  const {
    trashedOperations
  } = useJournal();
  const {
    user,
    signOut
  } = useAuth();
  return <aside className="hidden md:flex w-[248px] shrink-0 flex-col border-r border-line bg-white" data-id="element-350" data-mp="1gcs8vca52n0l">
      <div className="flex items-center gap-2.5 px-5 h-16 border-b border-line" data-id="element-351" data-mp="1w1nfr7xn3zie">
        <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-ink text-white" data-id="element-352" data-mp="1r8kkmvd7si03">
          <LineChartIcon className="h-4 w-4" strokeWidth={2.4} data-id="element-353" data-mp="1mbavzhxngadb" />
        </div>
        <div className="leading-tight" data-id="element-354" data-mp="1i97jqr35p1qz">
          <p className="text-[15px] font-semibold tracking-tight" data-id="element-355" data-mp="1ia8usvk69o8p">DZE Journal</p>
          <p className="text-[11px] text-ink-soft" data-id="element-356" data-mp="2exncew1kbr8b">Trading diary</p>
        </div>
      </div>

      <nav className="flex flex-col gap-0.5 p-3" data-id="element-357" data-mp="2a0wz2gh579ql">
        {items.map(({
        key,
        label,
        icon: Icon
      }) => {
        const on = active === key;
        return <button key={key} onClick={() => onChange(key)} className={cn('flex items-center gap-3 h-10 px-3 rounded-xl text-sm font-medium transition-colors', on ? 'bg-surface text-ink' : 'text-ink-soft hover:bg-surface/70 hover:text-ink')} data-id="element-358" data-mp="20z5pv1ne8krz">
              <Icon className="h-[18px] w-[18px]" strokeWidth={2} data-id="element-359" data-mp="qzctlrsufoge" />
              {label}
              {key === 'trash' && trashedOperations.length > 0 && <span className="ml-auto rounded-full bg-surface px-2 py-0.5 text-[11px] font-medium tabular-nums text-ink-soft" data-id="element-360" data-mp="hzprt4w7cgmt">
                  {trashedOperations.length}
                </span>}
            </button>;
      })}
      </nav>

      <div className="mt-auto p-4" data-id="element-361" data-mp="d1wlmbuwfmmj">
        <div className="rounded-xl border border-line bg-surface/60 p-3" data-id="element-362" data-mp="d26a1v0aplq4">
          <div className="flex items-center gap-2.5" data-id="element-363" data-mp="3uinxylpilzb3">
            {user?.avatarUrl ? <img src={user.avatarUrl} alt="" className="h-8 w-8 rounded-full object-cover" data-id="element-364" data-mp="3b1zr8lkep1m" /> : <div className="flex h-8 w-8 items-center justify-center rounded-full bg-ink text-[11px] font-semibold text-white" data-id="element-365" data-mp="3lgy8hlf71afy">
                {(user?.name ?? 'DZE').slice(0, 2).toUpperCase()}
              </div>}
            <div className="min-w-0" data-id="element-366" data-mp="36v11glj8sevm">
              <p className="truncate text-[12px] font-medium text-ink" data-id="element-367" data-mp="31veirwkna6ff">{user?.name}</p>
              <p className="truncate text-[11px] text-ink-soft" data-id="element-368" data-mp="31xr7cskwrf1g">{user?.email}</p>
            </div>
          </div>
          <button onClick={signOut} className="mt-2.5 w-full rounded-lg border border-line bg-white py-1.5 text-[12px] font-medium text-ink-soft hover:text-ink" data-id="element-369" data-mp="3btu75rsaf1l8">
            Cerrar sesión
          </button>
        </div>
      </div>
    </aside>;
}